// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1N9xd","ranges":"BmiRanges_ranges__1mDjo"};